export default "__VITE_ASSET__BtrNNtVi__"